import {Component, EventEmitter, OnInit, Output} from '@angular/core';

@Component({
    selector: 'app-garden-or-restuarant',
    templateUrl: './garden-or-restuarant.component.html',
    styleUrls: ['./garden-or-restuarant.component.scss'],
    standalone: false
})
export class GardenOrRestuarantComponent implements OnInit {
  @Output()
  reservationType: EventEmitter<string> = new EventEmitter<string>()

  constructor() { }

  ngOnInit(): void {
  }

  reserved(reservationType: string) {
    this.reservationType.emit(reservationType);
  }
}
